import axios from 'axios';

// Create a dedicated Axios instance for the public API.
const publicApi = axios.create({
  baseURL: 'https://bella-ceylon.onrender.com/api/public',
});

/**
 * Submits trip inquiry data to the public API endpoint.
 * @param {object} inquiryData - The complete inquiry form data.
 * @returns {Promise<object>} A promise that resolves to the success response from the server.
 */
const submitInquiry = async (inquiryData) => {
  try {
    const response = await publicApi.post('/inquiries', inquiryData);
    return response.data;
  } catch (error) {
    // Log the detailed error and re-throw it for the UI to handle and display messages.
    console.error('Error submitting inquiry:', error.response ? error.response.data : error.message);
    throw error;
  }
};

export { submitInquiry };